module.exports = __webpack_public_path__ + "static/media/typewriter.5a712e63.svg";